// Venue-confirmed admission/timing notes, scoped to the matching booking.
import { EVENT_EDITORIAL } from './popupEditorial';
export function screeningNote(showtime) {
  if (String(showtime.cinema_id || showtime.theaterId) === '65959'
      && String(showtime.movie_id) === '9707') {
    try {
      const url = new URL(showtime.booking_link);
      if (url.hostname === 'movingimage.org' && url.pathname.startsWith('/event/the-muppet-christmas-carol-the-uncut-version/'))
        return 'The uncut version, including “When Love Is Gone.”';
    } catch { /* Edition notes require the venue's exact event URL. */ }
  }
  if (showtime.id === 'manual-kid-brother-silent-clowns-20261108') return EVENT_EDITORIAL[showtime.id];
  if (String(showtime.cinema_id || showtime.theaterId) === '65749') {
    const booking = showtime.booking_link || '';
    if (/^https:\/\/commerce\.bam\.org\/booking\/production\/(59274|59275)$/.test(booking))
      return 'One admission for Chantal Akerman by Chantal Akerman + JLG/JLG: Self-Portrait in December. The listed time is the start of the complete program; separate film start times have not been announced. In French with English subtitles.';
    if (/^https:\/\/commerce\.bam\.org\/booking\/production\/(59268|59269)$/.test(booking))
      return 'One admission for Where Does Your Hidden Smile Lie? + Jean-Marie Straub and Danièle Huillet at Work on a Film Based on Franz Kafka’s Amerika. The listed time is the start of the complete program; separate film start times have not been announced. In French with English subtitles.';
  }
  if (String(showtime.cinema_id || showtime.theaterId) === '81345'
      && ['467445', '467446'].includes(String(showtime.movie_id))
      && ['2026-11-19T22:00:00-05:00', '2026-11-20T22:00:00-05:00'].some(t => Date.parse(t) === Date.parse(showtime.start_at))) {
    try {
      const url = new URL(showtime.booking_link);
      if (url.hostname === 'pools.events' && url.pathname === '/event/l9n0PFA7/trans-day-of-remembrance-at-spectacle/') {
        return '10 PM is the event start for the double feature The Salt Mines (1990) + The Transformation (1996), preceded by a poetry/discussion introduction. Separate film start times have not been announced. Proceeds benefit F2L (Fund the Inside).';
      }
    } catch { /* Only the reviewed benefit booking receives this note. */ }
  }
  if (String(showtime.cinema_id || showtime.theaterId) === '41518' && showtime.sold_out === true) {
    try {
      const url = new URL(showtime.booking_link);
      if (url.hostname === 'www.anthologyfilmarchives.org'
          && url.pathname === '/film_screenings/calendar'
          && /^#showing-\d+$/.test(url.hash)) {
        return 'Sold out. Anthology offers a standby line starting one hour before this screening.';
      }
    } catch { /* An unverified booking link cannot establish standby admission. */ }
  }
  if (String(showtime.cinema_id || showtime.theaterId) !== '60750'
      || String(showtime.movie_id) !== '205596'
      || Date.parse(showtime.start_at) !== Date.parse('2026-11-16T19:00:00-05:00')) return null;
  try {
    const url = new URL(showtime.booking_link);
    if (url.hostname !== 'tickets.paristheaternyc.com'
        || url.pathname !== '/order/showtimes/2001-3184/seats') return null;
  } catch { return null; }
  return '7 PM is the event start: The Altruists episode one and a conversation come before The Imitation Game. A separate start time for the film has not been announced. Free with RSVP.';
}
